/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	CreateDestinationRequest,
	Destination,
	DestinationListResponse,
	ListDestinationsParams,
	PraetoidError,
	TestEventResponse,
	UpdateDestinationRequest,
	WebhookEventTypeListResponse
} from '../models';

/**
 * Returns event destinations, optionally filtered by environment and/or type
 * @summary List event destinations
 */
export const listDestinations = (params: ListDestinationsParams) => {
	return customInstance<DestinationListResponse>({ url: `/destinations`, method: 'GET', params });
};

export const getListDestinationsQueryKey = (params?: ListDestinationsParams) => {
	return ['destinations', ...(params ? [params] : [])] as const;
};

export const getListDestinationsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDestinations>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListDestinationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDestinations>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListDestinationsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listDestinations>>> = () =>
		listDestinations(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listDestinations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof listDestinations>>>;
export type ListDestinationsQueryError = ErrorType<PraetoidError>;

export function useListDestinations<
	TData = Awaited<ReturnType<typeof listDestinations>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListDestinationsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDestinations>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDestinations>>,
					TError,
					Awaited<ReturnType<typeof listDestinations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDestinations<
	TData = Awaited<ReturnType<typeof listDestinations>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListDestinationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDestinations>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDestinations>>,
					TError,
					Awaited<ReturnType<typeof listDestinations>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDestinations<
	TData = Awaited<ReturnType<typeof listDestinations>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListDestinationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDestinations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List event destinations
 */

export function useListDestinations<
	TData = Awaited<ReturnType<typeof listDestinations>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListDestinationsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDestinations>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListDestinationsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new event destination for webhook delivery
 * @summary Create an event destination
 */
export const createDestination = (createDestinationRequest: CreateDestinationRequest) => {
	return customInstance<Destination>({
		url: `/destinations`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createDestinationRequest
	});
};

export const getCreateDestinationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createDestination>>,
		TError,
		{ data: CreateDestinationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createDestination>>,
	TError,
	{ data: CreateDestinationRequest },
	TContext
> => {
	const mutationKey = ['createDestination'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createDestination>>,
		{ data: CreateDestinationRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createDestination(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateDestinationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createDestination>>
>;
export type CreateDestinationMutationBody = CreateDestinationRequest;
export type CreateDestinationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create an event destination
 */
export const useCreateDestination = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createDestination>>,
			TError,
			{ data: CreateDestinationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createDestination>>,
	TError,
	{ data: CreateDestinationRequest },
	TContext
> => {
	return useMutation(getCreateDestinationMutationOptions(options), queryClient);
};
/**
 * Creates a new destination or updates an existing one based on environment_id and type
 * @summary Create or update an event destination
 */
export const upsertDestination = (createDestinationRequest: CreateDestinationRequest) => {
	return customInstance<Destination>({
		url: `/destinations`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: createDestinationRequest
	});
};

export const getUpsertDestinationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof upsertDestination>>,
		TError,
		{ data: CreateDestinationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof upsertDestination>>,
	TError,
	{ data: CreateDestinationRequest },
	TContext
> => {
	const mutationKey = ['upsertDestination'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof upsertDestination>>,
		{ data: CreateDestinationRequest }
	> = (props) => {
		const { data } = props ?? {};

		return upsertDestination(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpsertDestinationMutationResult = NonNullable<
	Awaited<ReturnType<typeof upsertDestination>>
>;
export type UpsertDestinationMutationBody = CreateDestinationRequest;
export type UpsertDestinationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create or update an event destination
 */
export const useUpsertDestination = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof upsertDestination>>,
			TError,
			{ data: CreateDestinationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof upsertDestination>>,
	TError,
	{ data: CreateDestinationRequest },
	TContext
> => {
	return useMutation(getUpsertDestinationMutationOptions(options), queryClient);
};
/**
 * Returns the list of event types that can be subscribed to via webhooks
 * @summary List webhook-eligible event types
 */
export const listWebhookEventTypes = () => {
	return customInstance<WebhookEventTypeListResponse>({
		url: `/destinations/webhooks/events`,
		method: 'GET'
	});
};

export const getListWebhookEventTypesQueryKey = () => {
	return ['destinations', 'webhooks', 'events'] as const;
};

export const getListWebhookEventTypesQueryOptions = <
	TData = Awaited<ReturnType<typeof listWebhookEventTypes>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listWebhookEventTypes>>, TError, TData>
	>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListWebhookEventTypesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebhookEventTypes>>> = () =>
		listWebhookEventTypes();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listWebhookEventTypes>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWebhookEventTypesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listWebhookEventTypes>>
>;
export type ListWebhookEventTypesQueryError = ErrorType<PraetoidError>;

export function useListWebhookEventTypes<
	TData = Awaited<ReturnType<typeof listWebhookEventTypes>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listWebhookEventTypes>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listWebhookEventTypes>>,
					TError,
					Awaited<ReturnType<typeof listWebhookEventTypes>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWebhookEventTypes<
	TData = Awaited<ReturnType<typeof listWebhookEventTypes>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listWebhookEventTypes>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listWebhookEventTypes>>,
					TError,
					Awaited<ReturnType<typeof listWebhookEventTypes>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWebhookEventTypes<
	TData = Awaited<ReturnType<typeof listWebhookEventTypes>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listWebhookEventTypes>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List webhook-eligible event types
 */

export function useListWebhookEventTypes<
	TData = Awaited<ReturnType<typeof listWebhookEventTypes>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listWebhookEventTypes>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListWebhookEventTypesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Deletes an event destination
 * @summary Delete an event destination
 */
export const deleteDestination = (id: string) => {
	return customInstance<void>({ url: `/destinations/${id}`, method: 'DELETE' });
};

export const getDeleteDestinationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteDestination>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteDestination>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['deleteDestination'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteDestination>>,
		{ id: string }
	> = (props) => {
		const { id } = props ?? {};

		return deleteDestination(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteDestinationMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteDestination>>
>;

export type DeleteDestinationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete an event destination
 */
export const useDeleteDestination = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteDestination>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deleteDestination>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDeleteDestinationMutationOptions(options), queryClient);
};
/**
 * Updates an existing event destination
 * @summary Update an event destination
 */
export const updateDestination = (
	id: string,
	updateDestinationRequest: UpdateDestinationRequest
) => {
	return customInstance<Destination>({
		url: `/destinations/${id}`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: updateDestinationRequest
	});
};

export const getUpdateDestinationMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateDestination>>,
		TError,
		{ id: string; data: UpdateDestinationRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateDestination>>,
	TError,
	{ id: string; data: UpdateDestinationRequest },
	TContext
> => {
	const mutationKey = ['updateDestination'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateDestination>>,
		{ id: string; data: UpdateDestinationRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateDestination(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateDestinationMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateDestination>>
>;
export type UpdateDestinationMutationBody = UpdateDestinationRequest;
export type UpdateDestinationMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update an event destination
 */
export const useUpdateDestination = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateDestination>>,
			TError,
			{ id: string; data: UpdateDestinationRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateDestination>>,
	TError,
	{ id: string; data: UpdateDestinationRequest },
	TContext
> => {
	return useMutation(getUpdateDestinationMutationOptions(options), queryClient);
};
/**
 * Sends a test webhook event to the specified destination with dummy data
 * @summary Send test event to destination
 */
export const sendTestEvent = (id: string) => {
	return customInstance<TestEventResponse>({ url: `/destinations/${id}/test`, method: 'POST' });
};

export const getSendTestEventMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendTestEvent>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof sendTestEvent>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['sendTestEvent'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestEvent>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return sendTestEvent(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type SendTestEventMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestEvent>>>;

export type SendTestEventMutationError = ErrorType<PraetoidError>;

/**
 * @summary Send test event to destination
 */
export const useSendTestEvent = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof sendTestEvent>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof sendTestEvent>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getSendTestEventMutationOptions(options), queryClient);
};
